<div
  class="faq-menu"
  [ngClass]="{ 'more-width': faqMoreWidth() }">
  <div class="faq-top-bar">
    <button
      class="no-style top-faq-text"
      aria-label="Faq Back Button"
      [ngClass]="{ 'top-faq-text--return': faqTabIndex() > 0 || generalTabIndex() > 0 }"
      (click)="reduceOnePage()">
      {{ (faqTabIndex() > 0 ? topicTitle() : 'faq.' + topicTitle()) | translate }}
      @if (subtitle()) {
        <span
          animate.enter="expand"
          animate.leave="shrink">
          - {{ subtitle() }}
        </span>
      }
    </button>
    <div class="faq-close-container">
      <coin-icon-button
        type="secondary"
        icon="close"
        (click)="closeFaq()"></coin-icon-button>
    </div>
  </div>
  @if (!helpData && !isLoading) {
    <div class="error-container">
      <div class="warning-icon">
        <mat-icon>warning</mat-icon>
      </div>
      <div class="warning-text">
        <p class="top-faq-text">{{ 'faq.no-faq-load-info' | translate }}</p>
        <p>{{ 'faq.reload-page-info' | translate }}</p>
      </div>
    </div>
  }
  @if (!isLoading && helpData) {
    @if (isSearchBarVisible) {
      <div class="faq-search-input">
        <coin-v2-text-input
          icon="search"
          aria-label="Faq Search"
          [placeholder]="'general.search-faq' | translate"
          [(ngModel)]="search"
          (input)="searchFaq()"></coin-v2-text-input>
      </div>
    }
    <div class="menu-container">
      <mat-tab-group
        class="main-tab-height"
        [selectedIndex]="generalTabIndex()">
        <mat-tab>
          <mat-tab-group
            class="main-tab-height"
            [selectedIndex]="faqTabIndex()">
            <mat-tab>
              <coin-siemens-energy-faq-top-level
                class="faq-base-tab"
                [items]="helpData"
                (openFaq)="openFaqFromSub($event)"
                (openOther)="onOpenOtherTopic($event)"></coin-siemens-energy-faq-top-level>
              <div class="chatbot-container">
                <coin-chat-bot></coin-chat-bot>
              </div>
            </mat-tab>
            @for (tab of faqTabs(); track tab) {
              <mat-tab>
                @if (tab?.content?.length === 0) {
                  <p class="faq-padding">{{ 'faq.no-items-found' | translate }}</p>
                }
                @if (!tab.isAnswer) {
                  @if (tab.title === 'HELP DESK') {
                    <coin-siemens-energy-faq-help-desk-level
                      [faqItem]="faqItem"
                      (openFaq)="openFaqFromSub($event)"></coin-siemens-energy-faq-help-desk-level>
                  } @else {
                    <coin-siemens-energy-faq-inbetween-level
                      class="faq-base-tab"
                      [items]="tab"
                      (openFaq)="openFaqFromSub($event)"></coin-siemens-energy-faq-inbetween-level>
                  }
                }
                @if (tab.isAnswer) {
                  <coin-siemens-energy-faq-answer-level
                    class="faq-base-tab"
                    [items]="tab"></coin-siemens-energy-faq-answer-level>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>
    </div>
  } @else {
    @if (isLoading) {
      <div class="loading-container">
        <app-loading-screen
          [local]="true"
          [contrast]="true"></app-loading-screen>
      </div>
    }
  }
  <div>
    <ng-template #loading>
      @if (isLoading) {
        <div class="loading-container">
          <app-loading-screen
            [local]="true"
            [contrast]="true"></app-loading-screen>
        </div>
      }
    </ng-template>
  </div>
</div>
